import { Flex, Input, Space } from 'antd';
import { BackButton, Container, Title, TitleTag } from './styles';
import { SearchOutlined } from '@ant-design/icons';
import { SVGArrowLeft } from '../../images';
import { useEffect, useState } from 'react';
import SearchInput from '../searchInput';

export interface ActionHeaderProps {
  title?: string;
  isSecondaryTitle?: boolean;
  titleTag?: string;
  showSearch?: boolean;
  isSearching?: boolean;
  onSearch?: (search?: string) => void;
  showBack?: boolean;
  onBack?: () => void;
  endSlot?: React.ReactNode;
  children?: React.ReactNode;
  maxWidth?: string | number;
  showBorder?: boolean;
}

const ActionHeader = ({
  title,
  isSecondaryTitle,
  titleTag,
  showSearch,
  isSearching,
  onSearch,
  showBack,
  onBack,
  endSlot,
  children,
  maxWidth,
  showBorder = true,
}: ActionHeaderProps) => {
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    //
  }, [search]);
  return (
    <Container className={showBorder ? 'bordered' : ''}>
      <Flex
        gap={12}
        style={maxWidth ? { maxWidth, margin: '0 auto', width: '100%' } : {}}
      >
        {showBack && (
          <BackButton onClick={onBack} title="Back">
            <SVGArrowLeft style={{ width: 28 }} />
          </BackButton>
        )}
        <Flex flex={1} vertical gap={16}>
          <Title align="center" className={isSecondaryTitle ? 'secondary' : ''}>
            {title}
            <TitleTag>{titleTag}</TitleTag>
          </Title>
          {showSearch && (
            <SearchInput
              placeholder={`Search for ${title?.toLocaleLowerCase()}`}
              onSearch={onSearch}
              isSearching={isSearching}
            />
          )}
        </Flex>
        {endSlot}
      </Flex>
      {children}
    </Container>
  );
};

export default ActionHeader;
